export default __webpack_public_path__ + "static/media/activeDot.ed8eb3a7.svg";